import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border: ", "px solid\n    ", ";\n  border-top: ", "px\n    solid ", ";\n  border-radius: 50%;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  box-sizing: border-box;\n  background: transparent;\n  :nth-child(2) {\n    transform: rotate(", "deg);\n    border: ", "px solid transparent;\n    border-top: ", "px solid\n      ", ";\n  }\n  :nth-child(3) {\n    transform: rotate(", "deg);\n    border: ", "px solid transparent;\n    border-top: ", "px solid\n      ", ";\n  }\n  :nth-child(4) {\n    transform: rotate(", "deg);\n    border: ", "px solid transparent;\n    border-top: ", "px solid\n      ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    animation: ", " 1s linear infinite;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  transform-origin: center center;\n  height: ", "px !important;\n  width: ", "px !important;\n  margin: auto;\n  background: transparent;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { times } from 'ramda';
import { compose, defaultProps, withProps } from 'recompose';
import styled, { keyframes, css } from '../utils/styling/styled-components';
import { SPINNER } from '../utils/testing/TestIDs';
import { getColorGradient, getNumColors } from './colorStops';
var SPINNER_SIZE = 52;
var SPINNER_BAR_SIZE = 2.25;
var spinnerAnimation = keyframes(_templateObject()); // Do some rounding for better subpixel rendering on different browsers

var roundToNearestQuarter = function roundToNearestQuarter(val) {
  return (Math.round(val * 4) / 4).toFixed(2);
};

var SpinnerContainer = styled.div(_templateObject2(), function (props) {
  return props.height ? props.height : SPINNER_SIZE;
}, function (props) {
  return props.width ? props.width : SPINNER_SIZE;
}, css(_templateObject3(), spinnerAnimation));
var SpinnerEl = styled.div(_templateObject4(), function (props) {
  return props.spinnerBarSize;
}, function (props) {
  return props.colors[0];
}, function (props) {
  return props.spinnerBarSize ? props.spinnerBarSize : SPINNER_BAR_SIZE;
}, function (props) {
  return props.colors[1];
}, function (props) {
  return props.rotation;
}, function (props) {
  return props.spinnerBarSize;
}, function (props) {
  return props.spinnerBarSize;
}, function (props) {
  return props.colors[2];
}, function (props) {
  return props.rotation * 2;
}, function (props) {
  return props.spinnerBarSize;
}, function (props) {
  return props.spinnerBarSize;
}, function (props) {
  return props.colors[3];
}, function (props) {
  return props.rotation * 3;
}, function (props) {
  return props.spinnerBarSize;
}, function (props) {
  return props.spinnerBarSize;
}, function (props) {
  return props.colors[4];
});
var enhance = compose(defaultProps({
  height: SPINNER_SIZE,
  width: SPINNER_SIZE
}), withProps(function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      white = _ref.white;
  var colorArr = getColorGradient(color); // For backwards compatibility - remove this once Web-App, Acorns-Hello, and other repos using this has changed all spinners to have color instead of white attribute and deployed to prod

  if (white) {
    colorArr = getColorGradient('white');
  }

  var numOfSlices = getNumColors(color) - 1;
  return {
    colors: colorArr,
    height: height,
    numOfSlices: numOfSlices,
    rotation: 180 / numOfSlices,
    // in degrees
    spinnerBarSize: roundToNearestQuarter(SPINNER_BAR_SIZE * width / SPINNER_SIZE),
    width: width
  };
}));
var Spinner = enhance(function (_ref2) {
  var className = _ref2.className,
      colors = _ref2.colors,
      height = _ref2.height,
      numOfSlices = _ref2.numOfSlices,
      rotation = _ref2.rotation,
      spinnerBarSize = _ref2.spinnerBarSize,
      width = _ref2.width;
  return /*#__PURE__*/React.createElement(SpinnerContainer, {
    className: className,
    height: height,
    width: width,
    "data-testid": SPINNER
  }, times(function (i) {
    return /*#__PURE__*/React.createElement(SpinnerEl, {
      key: i,
      colors: colors,
      rotation: rotation,
      spinnerBarSize: spinnerBarSize
    });
  }, numOfSlices));
});
export { Spinner };